// this page used for visiable cluster user table and edit user and submit the updated user.
import React, { Component, useEffect } from 'react'
import { connect } from 'react-redux'
import InputBase from '@material-ui/core/InputBase';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import swal from 'sweetalert'
import moment from 'moment'
import DialogActions from '@material-ui/core/DialogActions';
import { Grid, Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import axios from '../../http-config'
import ReactPaginate from 'react-paginate';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import * as actionsCreators from '../../store/actions/index'
import { withTranslation } from 'react-i18next';
import Clusterbulkupload from '../../Cluster_bulk_uploader.xlsx'
import TablePagination from '@material-ui/core/TablePagination';
import { DialogContent } from '@material-ui/core';

class ClusterUser extends Component {
 constructor(props){
     super(props)
     this.state ={
        openEditUser:false,
        anchorElEditUser:null,
        openeditPop: false,
        editUser:"",
        editEmail:"",
        editPass:"",
        editRole:"",
        roleOption:[],
        userId:"", 
        userName:"", 
        userEmail:"", 
        userROle:"",
        isPasswordShown:false,
        page:0,
        limit:10,
        userUlbID:""
     }
 }
componentDidMount(){
// console.log(this.props,"gggggggggggggggggggg")
axios({
    method: 'get',
    url: `/role`,
    headers: { 'Authorization': `Bearer ${this.props.token}` }
})
    .then((response) => {
        this.setState({ roleOption: response.data.data.slice(0, 4).filter((i) => i.id !== '4')})
       
    })
    let payload = {
        token:this.props.token,
        ULBId:this.props.match&&this.props.match.params.id
    }

    this.props.onGeClustersUser(payload)
}

  handleClickMoreVertIconEdit =(event, userId, userName, userEmail, userROle, userUlbID)=>{
        // console.log(event,"fffffffff")
        this.setState({ openEditUser: !this.state.openEditUser, anchorElEditUser: event.currentTarget, userId, userName, userEmail, userROle, userUlbID })
    }
    handleClickAwayEditUser = ()=>{
        this.setState({ openEditUser: false });
    }
    handleCloseEditPop = () => {
        this.setState({
            openeditPop: false,
            editUser:"",
            editEmail:"",
            editPass:"",
            editRole:"",
        })
    }

    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
     
     handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
}
    handleSubmitEditUser = () => {
        const payload = {
            email :this.state.editEmail,
            username :this.state.editUser,
            password : this.state.editPass,
            role :this.state.editRole ,
            userId :this.state.userId,
            userULBId : this.state.userUlbID
        }
        let SubmitProp = this.props
        this.props.onEditUserCluster(payload, SubmitProp)
        this.setState({editUser: "", editPass: "", editRole: "", editEmail: "", openeditPop: false})
     }
     editClusterUser = (id, name, email, roleId)=>{
        this.setState({
            openeditPop: true,
            editUser:name,
            editEmail:email,
            editRole:roleId,
        })
     }
     handleChangePage = (event, newPage) => {
        // console.log(this.state.page, "PAGE");
         this.setState({page: newPage})
       };
       handleChangeRowsPerPage = (event) => {
         this.setState({limit:parseInt(event.target.value, 10),page:0});
         
       };
 
     
    render() {
        const {t, i18n} = this.props

        // console.log(this.props,"gggggvvvvvvvvvv")
        let userHeader = [
            {
                accessor: "UserName",
                filter: "false",
                header: "User Name",
                sortable: "false",
            },
            {
                accessor: "Email",
                filter: "false",
                header: "Email",
                sortable: "false",
            },
            {
                accessor: "Name",
                filter: "false",
                header: "Role",
                sortable: "false",
            },
            {
                accessor: "actionEdit",
                filter: "false",
                header: "Action",
                sortable: "false",
            },
        ]
    
    
        const UserHeader = !!userHeader&&userHeader.map((header)=>{
            return(
                <TableCell key={header.header} className={"white-space"}>
                <div style={{
                    display: 'flex',
                    alignItems: 'start',
                    whiteSpace: 'break-spaces',
                    height: '3em'
                }}>
    
                    {header.header}
                </div>
            </TableCell>
            )
        })
    
        const userListingCluster = !!this.props.getClusterUserData&&this.props.getClusterUserData.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit).map((item, index)=>{
            const userId = item.Id
            const userName = item.UserName
            const userEmail = item.Email
            const userROle = item.RoleId
            const userUlbID = item.ULBId
            return (
                <TableRow key={index}>
    {
         !!userHeader&&userHeader.map((header)=>{
            if (header.accessor == 'actionEdit') {
                return <TableCell key={header.accessor}>
                    <IconButton onClick={(e) => this.handleClickMoreVertIconEdit(e,userId, userName, userEmail, userROle, userUlbID)}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true">
                        <MoreVertIcon fontSize='small' />
                    </IconButton>
                    <Popper open={this.state.openEditUser} anchorEl={this.state.anchorElEditUser}>
                        <ClickAwayListener onClickAway={this.handleClickAwayEditUser}>
                            <Paper style={{ boxShadow: "none", border: "1px solid rgb(61, 171, 53)" }}>
                                <MenuList>
                                    <MenuItem className='email_link' onClick={() => this.editClusterUser(this.state.userId, this.state.userName, this.state.userEmail,this.state.userROle)} style={{color: '#3dab35'}}>{t("editUser")}</MenuItem>
                                </MenuList>
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                </TableCell>
            }
         
            else {
                return <TableCell style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word"
                }} key={header.accessor} 
                     className={"white-space"}>
                    {item[header.accessor]}
                      </TableCell>
            }
         })
    }
                </TableRow>
            )
        })
    return (
            <div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                    <div className="dashboard_right_content_top">
                    <h5><Link to = "/cluster-management" className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link> {t("clusterUser")}</h5>
                    </div>
                      
                    <div className="ulb_listing " >
                <TableContainer component={Paper} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                    <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                   
                        <TableHead >
                            <TableRow >
                                {UserHeader}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                       
                            {userListingCluster }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


            {
                this.props.totalCountCUser && this.props.totalCountCUser != 0 &&
                <TablePagination
                rowsPerPageOptions={[10,50,100]}
                colSpan={3}
                count={this.props.totalCountCUser}
                component="div"
                rowsPerPage={this.state.limit}
                page={this.state.page}
                SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
                }}
                labelRowsPerPage={("Rows per page")}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
            }
                    </div>





    {/* for edit user  */}
        <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        open={this.state.openeditPop}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>Edit User </span></DialogTitle>
        <DialogContent>
        <div className="create_ulb_content_outer">
                <div className="create_ulb_content create_ulb_contentPop">
                                    <Grid container spacing={4}>
                                        <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="username">{t("userName")}</label>
                                                    <TextField id="username"
                                                        variant="outlined"
                                                        placeholder= {`${t("enterUser")}`}
                                                        name='editUser'
                                                        value={this.state.editUser}
                                                        onChange={(e) => this.handleInputChange(e)} />
                                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.usernameErr}</div>
                                                </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="email">{t("email")}</label>
                                                <TextField id="email"
                                                    variant="outlined"
                                                    placeholder= {`${t("enterEmail")}`}
                                                    name="editEmail"
                                                    value={this.state.editEmail}
                                                    onChange={(e) => this.handleInputChange(e)} />
                                                <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.emailErr}</div>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                        <form autocomplete="off">
                                        <FormControl>
                                        <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("userPass")}</label>
                      
                                        <OutlinedInput id = "password" 
                                                        variant="outlined" 
                                                        placeholder= {`${t("enterPass")}`} 
                                                        name="editPass" 
                                                        value={this.state.editPass}
                                                        onChange={(e) => this.handleInputChange(e)}
                                                        type={this.state.isPasswordShown ? "text" : "password"}
                                                        endAdornment={this.state.isPasswordShown ?
                                                            (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                                            onClick={()=>{this.toggleVisibility()}}
                                                            /></InputAdornment>) :
                                                            (<InputAdornment position="end">
                                                                <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={()=>{this.toggleVisibility()}}
                                                                >
                                                                <img src="images/eye.svg" />
                                                            </IconButton> </InputAdornment> )    
                                                            }
                                                            errortext={this.state.passwordError}    
                                        />
                                     
                                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                                            </FormControl>
                                            </form>
                                            </Grid>
                                            <Grid item xs={6}>
                                              
                                                <FormControl fullWidth>
                                                    <label className="required" htmlFor="role" align="left">{t("role")}</label>
                                                    <Select value={this.state.editRole} onChange={(e) => this.handleInputChange(e)} name="editRole">
                                                                {
                                                                this.state.roleOption                          
                                                                .map((option) =>  
                                                                    <MenuItem value={option.roleId}>{option.name}</MenuItem> 
                                                                )}
                                                    </Select> 
                                                         
                                                </FormControl>
                                              
                                            </Grid>      
                                    </Grid>
                                    
            {this.state.openeditPop === true? 
        <Grid container spacing={1}>
        <Grid item xs={12}>
         <div className="create_ulb_buttons" style={{marginBottom:'10px'}}>
                    <Button className='login_submit' variant='contained' color='primary' onClick={this.handleCloseEditPop}>{t("cancel")}</Button>
                    <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmitEditUser}>{t("saveChange")}</Button>
         </div>
            </Grid>
        </Grid>:""}
        
        </div>
        </div>
        </DialogContent>
        </Dialog>
       
                </div>
       );
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        totalCountCUser: state.ClusterLIstingReducer.totalCountUser,
        getClusterUserData : state.ClusterLIstingReducer.getListingCluster
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onEditUserCluster: (payload, SubmitProp) => dispatch(actionsCreators.editUserCluster(payload, SubmitProp)),
        onGeClustersUser: (payload)=> dispatch(actionsCreators.getDataForEditUser(payload))
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(withTranslation()( ClusterUser, axios));
